var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUploadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33338 11.3333C4.50202 11.3339 3.70045 11.0238 3.08596 10.4638C2.47147 9.90383 2.08841 9.13445 2.01194 8.30661C1.93547 7.47878 2.17111 6.65225 2.67262 5.98919C3.17413 5.32613 3.90532 4.87441 4.72271 4.72267C4.86628 3.95845 5.27241 3.26842 5.87086 2.77193C6.46931 2.27544 7.22245 2.0037 8.00004 2.0037C8.77763 2.0037 9.53078 2.27544 10.1292 2.77193C10.7277 3.26842 11.1338 3.95845 11.2774 4.72267C12.092 4.8775 12.8198 5.33031 13.3186 5.99274C13.8174 6.65518 14.0515 7.4797 13.9753 8.30542C13.899 9.13115 13.5178 9.89883 12.9061 10.4587C12.2943 11.0185 11.4959 11.3304 10.6667 11.3333M6.00004 8L8.00004 6M8.00004 6L10 8M8.00004 6V14",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadOutline);
export default __webpack_public_path__ + "static/media/CloudUploadOutline.ae57c6f793340f9889c5c4864d46cf89.svg";
export { ForwardRef as ReactComponent };